import { render, staticRenderFns } from "./BankListWithdrawal.vue?vue&type=template&id=dfefd28e&lang=pug"
import script from "./BankListWithdrawal.vue?vue&type=script&lang=js"
export * from "./BankListWithdrawal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports